import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { RouteComponentProps } from "react-router";
import { Link } from "react-router-dom";
import { login } from '../modules/auth';
import { RootState } from '../modules';

import Http from '../lib/Http';

type MatchParams = {
	emailId: string
};

function LoginContainer({ match }: RouteComponentProps<MatchParams>) {
	const { register, handleSubmit, errors } = useForm();
	const [emails, setEmails] = useState([]);

	const dispatch = useDispatch();

	const auth = useSelector((state: RootState) => state.auth);

	const onSubmit = (data: any) => {
		dispatch(login.request(data));
	}

	const getEmails = async () => {
		const { data } = await Http.get(
			'emails?limit=10&offset=0&sortBy=created_time',
		);
		setEmails(data.items);
	}

	return (
		<div>
			{
				auth.token !== undefined ? (
					<div>
						<h2>
							이메일 목록 
						</h2>
						<button onClick={getEmails}>
							이메일 목록 가져오기
						</button>
						<ul>
							{
								emails.map((item:any, index:number) => (
									<li key={index}>
										<Link to={`/editor/${item.id}`}>{item.id} - {item.subjectA}</Link>
									</li>
								))
							}
						</ul>
					</div>
				) : (
					<form onSubmit={handleSubmit(onSubmit)}>
						<p>qa.stibee.com id/pw로 로그인</p>
						<fieldset>
							<input type="text" name="userId" placeholder="이메일" ref={register({ required: true })}/>
						</fieldset>
						<fieldset>
							<input type="password" name="password" placeholder="패스워드" ref={register({ required: true })}/>
						</fieldset>
						<fieldset>
							<button type="submit">로그인</button>
						</fieldset>
					</form>
				)
			}
		</div>
	);
}

export default LoginContainer;